module.exports = __webpack_public_path__ + "static/media/no-videos-found.4d56b44d.svg";